import styled from 'styled-components';

export const ChildrenCountDisplay = styled.div`
    margin: 0 10px;
`;
